import React from "react";
import CustomSelect from "./select.js";
import { rowsPerPageSelectOptions } from "../../constants/pagination.js";

/**
 * Rows-per-page dropdown shared across Clients, Orders, Menu, Telegram payments, Promocodes, etc.
 */
const RowsPerPageSelect = ({
    label,
    value,
    onChange,
    margin = "",
    menuPlacement = "auto",
}) => (
    <CustomSelect
        label={label}
        options={rowsPerPageSelectOptions}
        value={value}
        onChange={(selectedOption) => {
            if (selectedOption) {
                onChange(Number(selectedOption.value));
            }
        }}
        margin={margin}
        isRequired={false}
        showRequiredIndicator={false}
        menuPlacement={menuPlacement}
    />
);

export default RowsPerPageSelect;
